import { api } from '@/lib/api/client'
import type { Guest, GuestInvite } from '@/types/work'

export async function fetchGuests(projectKey: string): Promise<Guest[]> {
  const { data } = await api.get<{ data: Guest[] }>(`/projects/${projectKey}/guests`)

  return data.data
}

export async function inviteGuest(
  projectKey: string,
  input: { email: string; expiresInDays?: number },
): Promise<GuestInvite> {
  const { data } = await api.post<{ data: GuestInvite }>(`/projects/${projectKey}/guests`, input)

  return data.data
}

export async function revokeGuest(projectKey: string, membershipId: string): Promise<void> {
  await api.delete(`/projects/${projectKey}/guests/${membershipId}`)
}

export async function fetchInvitation(token: string): Promise<{ email: string; expiresAt: string }> {
  const { data } = await api.get<{ data: { email: string; expiresAt: string } }>(
    `/invitations/${token}`,
  )

  return data.data
}

export async function acceptInvitation(token: string, name: string): Promise<void> {
  await api.post(`/invitations/${token}/accept`, { name })
}
